import HeroBanner from '../../../components/organisms/heroBanner';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';

const ComplexHeroTastic = ({ data, context }) => {
  if (!data) return null;
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <HeroBanner data={data} />;
};

ComplexHeroTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: { context: true },
})(ComplexHeroTastic);
